import React, { createContext, useContext, useState } from "react";
import { Alert } from "@mui/material";
import "../css/alert.css";

const AlertContext = createContext();

export const useAlert = () => {
  return useContext(AlertContext);
};

const AlertProvider = ({ children }) => {
  const [alertData, setAlertData] = useState(null);

  const showAlert = (severity, message) => {
    setAlertData({ severity, message });
    setTimeout(() => {
      closeAlert();
    }, 2000); // Auto-close after 2 seconds
  };

  const closeAlert = () => {
    setAlertData(null);
  };

  return (
    <AlertContext.Provider value={{ showAlert }}>
      {children}
      {/* Display the alert */}
      {alertData && (
        <div className="alert-container">
          <Alert severity={alertData.severity} onClose={closeAlert}>
            {alertData.message}
          </Alert>
        </div>
      )}
    </AlertContext.Provider>
  );
};

export default AlertProvider;
